import { render, staticRenderFns } from "./storageAssetsDetails.vue?vue&type=template&id=1a6f50a9&scoped=true&"
import script from "./storageAssetsDetails.vue?vue&type=script&lang=js&"
export * from "./storageAssetsDetails.vue?vue&type=script&lang=js&"
import style0 from "./storageAssetsDetails.vue?vue&type=style&index=0&id=1a6f50a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f50a9",
  null
  
)

export default component.exports